import {
    ADDGATEWAYACCOUNT_SUCCESS,
    ADDGATEWAYACCOUNT_FAILED,
    RESET_ADDGATEWAYACCOUNT,
    LOADING_ADDGATEWAYACCOUNT,
    NETWORK_ERROR_ADDGATEWAYACCOUNT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDGATEWAYACCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDGATEWAYACCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDGATEWAYACCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
